import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux';

import cycleRoutes from './cycleRoutes';
import leisureRides from './leisureRides';
import locations from './locations';
import currentJourney from './currentJourney';
import POI from './POI';
import cycleHire from './cycleHire';
import map from './map';
import errors from './errors';
import sidebar from './sidebar';
import filters from './filters';
import LCN from './lcn';
import SR from './sr';
import SUS from './sus';
import header from './header';

const rootReducer = combineReducers({ cycleRoutes, leisureRides, LCN, SR, SUS, locations, currentJourney, POI, cycleHire, map, errors, sidebar, filters, header, routing: routerReducer });

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js